module.exports = __webpack_public_path__ + "img/add-image7.710d6484.png";